import { Attrs, MinzeElement } from 'minze'

export class LvcTabGroupLoader extends MinzeElement {
  attrs: Attrs = [['global-padding', true]]
  html = () => `
    <div class="${this.globalPadding ? 'padding-global' : ''} lvc-tab-group-loader__component">
      <div class="lvc-tab-group-loader__top-content-wrapper">
        <div class="lvc-tab-group-loader__tabs-wrapper">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
        <div class="lvc-tab-group-loader__geo"></div>
      </div>
      <div class="lvc-tab-group-loader__bottom-content-wrapper">
        <div></div>
        <div></div>
        <div></div>
    </div>
  `
  css = () => `
     .padding-global {
      padding-left: 6rem;
      padding-right: 6rem;
  }
  @media screen and (max-width: 991px) {
      .padding-global {
        padding-left: 4.5rem;
        padding-right: 4.5rem;
      }
    }
    @media screen and (max-width: 767px) {
      :host {
        margin-left: ${this.globalPadding ? '0' : '1rem'};
        margin-right: ${this.globalPadding ? '0' : '1rem'};
      }
      .padding-global {
        padding-left: 1rem;
        padding-right: 1rem;
      }
    }
    .lvc-tab-group-loader__top-content-wrapper {
      display: grid;
      grid-template-columns: 1fr 200px;
      height: 100%;
    }
    .lvc-tab-group-loader__tabs-wrapper {
      margin-top: 1rem;
      width: 100%;
      display: grid;
      grid-template-columns: repeat(5, 1fr);
      gap: 1rem
    }
    .lvc-tab-group-loader__tabs-wrapper > div {
      height: 44px;
      background-color: rgba(0, 0, 0, 0.1);
      border-radius: 999px;
      animation: loading 3s infinite;
    }
    .lvc-tab-group-loader__geo {
      width: 100%;
      height: 44px;
      background-color: rgba(0, 0, 0, 0.1);
      border-radius: 999px;
      animation: loading 3s infinite;
    }
    .lvc-tab-group-loader__bottom-content-wrapper {
      margin-top: 7rem;
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 1rem;
    }
    .lvc-tab-group-loader__bottom-content-wrapper > div:nth-child(1) {
      grid-column: span 2;
      width: 100%;
      height: 350px;
      background-color: rgba(0, 0, 0, 0.1);
      border-radius: 24px;
    }
    .lvc-tab-group-loader__bottom-content-wrapper > div {
      height: 170px;
      width: 100%;
      background-color: rgba(0, 0, 0, 0.1);
      border-radius: 24px;
      animation: loading 3s infinite;
    }
    @media only screen and (max-width: 991px) {
      .lvc-tab-group-loader__top-content-wrapper {
        grid-template-columns: 1fr;
      }
      .lvc-tab-group-loader__bottom-content-wrapper {
        grid-template-columns: 1fr;
        gap: 3rem;
        margin-top: 5rem;
      }

      .lvc-tab-group-loader__tabs-wrapper {
        display:none;
      }
      .lvc-tab-group-loader__geo {
        height: 60px;
      }
      .lvc-tab-group-loader__bottom-content-wrapper > div{
        height: 350px;
      }
      .lvc-tab-group-loader__bottom-content-wrapper > div:nth-child(1) {
        grid-column: span 1;
        height: 350px;
      }
    }
    @keyframes loading {
      0% {
        background-color: rgba(0, 0, 0, 0.1);
      }
      50% {
        background-color: rgba(0, 0, 0, 0.2);
      }
      100% {
        background-color: rgba(0, 0, 0, 0.1);
      }
    }
  `
}
